import React from "react";
import PropTypes from "prop-types";
import _get from "lodash/get";

import fields from "./createGLCodeFields";
import { FormPageSection } from "../../../layout/FormPageSection";
import { LabeledText } from "../../../inputs/LabeledText";

const getGLCodeTexts = values =>
  (_get(values, "glCodes", []) || [])
    .map(glCode => glCode && glCode.description)
    .filter(Boolean);

const GLCodesSection = ({ values, clientId, isVendorPortal }) => {
  if (isVendorPortal) {
    const texts = getGLCodeTexts(values);
    return (
      <FormPageSection
        headerText="GL Codes"
        isPage={true}
        fields={{ groups: [] }}
        values={values}
      >
        <LabeledText texts={texts.length ? texts : ["—"]} />
      </FormPageSection>
    );
  }

  return (
    <FormPageSection
      headerText="GL Codes"
      isPage={true}
      fields={fields(clientId)}
      values={values}
    />
  );
};

GLCodesSection.propTypes = {
  values: PropTypes.shape({}),
  clientId: PropTypes.string.isRequired,
  isVendorPortal: PropTypes.bool,
};

export default GLCodesSection;
